// extracted by mini-css-extract-plugin
export default {"section":"Home_section__ejtmr","sectionTitle":"Home_sectionTitle__UiIOL","footer":"Home_footer__JlTvt"};